import Scrollbar, { ScrollbarPlugin } from 'smooth-scrollbar';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
class SmoothScroll {

  constructor(responsive) {
    if (responsive.mobile == true) {
      gsap.registerPlugin(ScrollTrigger);
      this.pageScroller = false;
    } else {
      // Smooth Scroller init
      let options = {
        damping: 0.1,
        renderByPixel: true,
      };
      let pageScrollerWrapper =
        document.querySelector('#scroll-section');

      Scrollbar.use(pauseScrollPlugin);
      this.pageScroller = Scrollbar.init(pageScrollerWrapper, options);

      // Gsap and smooth scroller link
      gsap.registerPlugin(ScrollTrigger);

      let that = this;
      ScrollTrigger.scrollerProxy('#scroll-section', {
        scrollTop(value) {
          if (arguments.length) {
            that.pageScroller.scrollTop = value;
          }
          return that.pageScroller.scrollTop;
        },
      });
      this.pageScroller.addListener(ScrollTrigger.update);
      ScrollTrigger.defaults({ scroller: pageScrollerWrapper });

      //set position and remove x axis
      this.pageScroller.setPosition(0, 0);
      this.pageScroller.track.xAxis.element.remove();

      //Inits
      document.body.classList.add('smooth-scrollbar-active');
    }

    this.initHeader();
  }

  initHeader() {
    let fixed = document.querySelector('header');

    if (this.pageScroller == false) {
      fixed.style.top = '0';
      window.addEventListener('scroll', () => {
        if (window.scrollY > 100) {
          fixed.classList.add('mini');
        } else {
          fixed.classList.remove('mini');
        }
      });
    } else {
      this.pageScroller.addListener(({ offset }) => {
        if (fixed) {
          // scroll offset
          fixed.style.top = offset.y + 'px';

          // Toggle mini header
          if (this.pageScroller.offset.y > 100) {
            fixed.classList.add('mini');
          } else {
            fixed.classList.remove('mini');
          }
          this.pageScroller.setPosition(0, this.pageScroller.offset.y);
        }
      });
    }
  }

  pauseSmoothScroll(bool) {
    if (this.pageScroller == false) {
      document.body.classList.toggle('stop-scroll');
    } else {
      this.pageScroller.updatePluginOptions('pause-scroll', {
        open: bool,
      });
    }
  }

  customScrollTo(el) {
    if (this.pageScroller == false) {
      el.scrollIntoView({behavior: 'smooth'});
    } else {
      this.pageScroller.scrollTo(0, el.offsetTop, 1250);
    }
  }
}
class pauseScrollPlugin extends ScrollbarPlugin {
  static pluginName = 'pause-scroll';
  static defaultOptions = {
    open: false,
  };
  transformDelta(delta) {
    return this.options.open ? { x: 0, y: 0 } : delta;
  }
}

export default SmoothScroll;

